import React, { PureComponent } from 'react';

import cls from 'classnames/bind';
import s from './LoadingArrows.scss';

const cx = cls.bind(s);

class LoadingArrows extends PureComponent {
  static defaultProps = {
    width: 30,
    style: {},
    fill: '#FEFEFE',
  };

  constructor(props, ctx) {
    super();
  }

  render() {
    const { width, fill } = this.props;
    return (
      <svg
        className={cx('LoadingArrows')}
        {...this.props}
        width={width}
        height={width}
        viewBox={`-3.133 -7.231 76 76`}
        x="0px"
        y="0px"
        overflow="visible"
        enableBackground="new -3.133 -7.231 76 76"
        xmlSpace="preserve"
      >
        <g fill={fill}>
          <path d="M64.589,22.933C61.132,9.753,49.119,0,34.869,0c0,0,0,0-0.001,0C22.731,0,11.706,7.169,6.778,18.264  c-0.561,1.262,0.008,2.739,1.27,3.299c1.262,0.561,2.74-0.008,3.299-1.27C15.474,11.002,24.707,5,34.869,5  c11.775,0,21.723,7.957,24.764,18.774l-5.254,0.891l9.936,11.996l5.42-14.601L64.589,22.933z" />
          <path d="M61.685,39.972c-1.26-0.559-2.738,0.01-3.299,1.271c-4.127,9.291-13.359,15.293-23.521,15.293  c-11.777,0-21.724-7.957-24.764-18.773l5.252-0.893L5.42,24.875L0,39.476l5.143-0.873c3.458,13.182,15.472,22.934,29.723,22.934  c12.136,0,23.163-7.168,28.091-18.264C63.517,42.011,62.947,40.532,61.685,39.972z" />
        </g>
      </svg>
    );
  }
}

module.exports = LoadingArrows;
